<template>
    <v-container fluid>
        <div class="title font-weight-bold">
            PMS Case Number: {{ form.pmsCaseNumber }}
        </div>
        <v-row>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-text-field v-model="form.name" readonly class="primary-label">
                    <template v-slot:label>
                        <span class="font-weight-bold">Full Name</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-text-field v-model="form.email" readonly class="primary-label">
                    <template v-slot:label>
                        <span class="font-weight-bold">Email</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-text-field v-model="form.healthConcern" readonly class="primary-label">
                    <template v-slot:label>
                        <span class="font-weight-bold">Health Concern</span>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-menu
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.date"
                        label="Preferred Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requiredRules"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="form.date"
                        @input="datePickerMenu = false"
                        :min="allowedDate"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-menu
                    ref="menu"
                    v-model="timePickerMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.time"
                        label="Preferred Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requiredRules"
                    ></v-text-field>
                    </template>
                    <v-time-picker
                        v-if="timePickerMenu"
                        v-model="form.time"
                        :allowed-minutes="allowedStep"
                        full-width
                        @click:minute="$refs.menu.save(form.time)"
                    ></v-time-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
            </v-col>
            <v-col cols="12" md="4" lg="4" xl="4">
                <v-radio-group
                    v-model="form.preferred_method"
                    row
                    mandatory
                >
                    <v-radio
                        label="Audio"
                        value="audio"
                    ></v-radio>
                    <v-radio
                        label="Video"
                        value="video"
                    ></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    props: {
        form: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data: () => ({
        datePickerMenu: false,
        timePickerMenu: false,
        requiredRules: [value => !!value || "This field is required."],
        allowedDate: moment().format("Y-MM-DD")
    }),
    methods: {
        // allowedMinutes: v => v >= 10 && v <= 50,
        allowedStep: m => m % 5 === 0,
    }
};
</script>